import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withCookies } from 'react-cookie'
import { AddToTrolley, BackToTop, ErrorBoundary, Propbar } from '@sainsburys-tech/bolt'
import { smooth } from '@sainsburys-tech/boltui-utils'

import { InView } from 'react-intersection-observer'
import LazyHydrate from 'react-lazy-hydration'
import loadable from '@loadable/component'

import { isInCategoryExperiencesGroup } from '../helpers/abTestHelper'
import { trackClickQuantityStickyBar } from './EventTrackers'
import { getInitialNavInfo } from '../components/AddToTrolleySticky/StickyNavigationList'
import MadeToOrderTemplate from './MadeToOrderTemplate'
import AdditionalInformation from '../components/AdditionalInformation/AdditionalInformation'
import { getPreferredCreditPlans } from '../helpers/creditPlanHelper'

import DefaultHeadingSection from './sections/DefaultHeadingSection'
import BreadcrumbSection from './sections/BreadcrumbSection'
import MediaGallerySection from './sections/MediaGallerySection'
import PricingModuleSection from './sections/PricingModuleSection'
import ContentSection from './sections/ContentSection'
import AccordionsSection from './sections/AccordionsSection'
import Recommender from '../components/Recommender/Recommender'
import CustomerGeneratedContentWrapper from '../containers/CustomerGeneratedContentWrapper/CustomerGeneratedContentWrapper'
import AskTrevorCTA from '@/components/AskTrevor/AskTrevorCTA'

import OverwriteThemeIfNeeded from '../components/OverwriteThemeIfNeeded/OverwriteThemeIfNeeded'
import StructuredDataAvailabilityUpdater from '../components/StructuredDataAvailabilityUpdater/StructuredDataAvailabilityUpdater'
import { AoOosMessageKeys } from '../config/ao-oos-message-keys'
import { Wrapper, MediaGalleryBox } from './DefaultTemplate.styles'

// WhiteGoods //TODO don't load (loadable) if not used
import transformSpecification from '../helpers/specificationTransformation'
import { FeatureFlagContextConsumer } from '../providers/FeatureFlagContext/FeatureFlagContext'

const SpecificationContainer = loadable(() =>
  import(/* webpackChunkName: "specification-container" */ '../components/Specification/SpecificationContainer')
)

// TU
const ComparisonAttributes = loadable(() =>
  import(/* webpackChunkName: "comparison-attributes" */ '../components/ComparisonAttributes/ComparisonAttributes')
)

// ALL
const FeaturedProductsContainer = loadable(() =>
  import(
    /* webpackChunkName: "featured-products-container" */ '../components/FeaturedProducts/FeaturedProductsContainer'
  )
)
const AlternativesHOC = loadable(() =>
  import(/* webpackChunkName: "AlternativesHOC" */ '../components/Alternatives/AlternativesHOC')
)

class DefaultTemplate extends Component {
  constructor(props) {
    super(props)

    const {
      offers = [],
      bundles = [],
      reviews = [],
      isCNETContent = false,
      nutrition = {},
      productId,
      FREQUENTY_BROUHT_TOGETHER,
      ASK_QUESTION,
      Q_AND_A,
      CNET
    } = this.props

    this.state = {
      currentlyInViewport: getInitialNavInfo({
        offers,
        bundles,
        reviews,
        isCNETContent: !CNET ? false : isCNETContent,
        nutrition,
        productId,
        FREQUENTY_BROUHT_TOGETHER,
        ASK_QUESTION,
        Q_AND_A
      }),
      loadAlternatives: false,
      loadShopCollection: false,
      loadRecommender: false,
      featuredProductsLoaded: false,
      noOHATRecs: false
    }
  }

  trackUpdateTrolleyQuantity = event => {
    const {
      target: {
        value,
        offsetParent: { className }
      }
    } = event
    const { isLocalised } = this.props.storeLocator
    const fulfilmentModule = document.querySelector('.fulfilment')
    const duration = 1000
    const isSticky = className.includes('sticky-bar')
    this.props.updateQuantity({ quantity: value })
    if (isSticky && isLocalised) {
      smooth.scrollHere(fulfilmentModule, 0, duration)
    }

    trackClickQuantityStickyBar()
  }

  setNoOHATRecsExist = () => {
    this.setState(state => ({ ...state, noOHATRecs: true }))
  }

  render = () => {
    const {
      ar,
      attributes,
      badges,
      breadcrumb,
      bundles = [],
      categories,
      comparison,
      creditPlans,
      dimensions,
      energy,
      essentialExtras,
      isCNETContent,
      legalText,
      media,
      nutrition,
      offers = [],
      prices,
      priorityMeta,
      productCare,
      productId,
      quantity,
      ratingSummary,
      reviewStatistics,
      storeLocator,
      warrantyProductDetails,
      variants,
      ASK_QUESTION,
      ATT_MODAL_HIDE_CATEGORIES,
      ATT_MODAL_HIDE_EXTRAS,
      BREADCRUMB,
      CATEGORY_EXPERIENCES_TEMPLATE_ENABLED,
      CNET,
      COMPARISON_ATTRIBUTES,
      COMPLETE_THE_LOOK,
      CUSTOMER_GENERATED_CONTENT,
      DESCRIPTION_CLASS,
      FEATURED_PRODUCTS,
      FREQUENTY_BROUHT_TOGETHER,
      GO_IN_STORE,
      MEDIA_CLASS,
      MEDIA_PORTRAIT,
      MONTHLY_PAYMENT_PLAN,
      PAYPAL_IFC_MESSAGING,
      SHOW_ARGOSCARD_LOGO_FINANCE_ACCORDION,
      PAYPAL_MESSAGING,
      KLARNA_CREDITPLAN,
      KLARNA_MESSAGING,
      PDP_V2_FLAG,
      PRICING_CLASS,
      SHOP_COLLECTION,
      SOLD_BY_ARGOS,
      SPECIFICATION_TABLE,
      TEMPLATE_TYPE,
      WISHLIST,
      REMOVED_SPECIFICATIONS,
      ITEM_CONTAINER,
      NECTAR,
      ESSENTIAL_EXTRAS,
      isMadeToOrder,
      brandLogoUrl,
      ASK_TREVOR_ENABLED
    } = this.props
    const {
      partNumber,
      globallyOutOfStock,
      endOfLineOutOfStock,
      preorderUnavailable,
      name,
      brand,
      description,
      deliverable,
      collectable,
      maximumQuantity,
      parentId,
      digitalDownload,
      fulfilmentAgent,
      sdf
    } = attributes

    const { highestPriorityArgosCardPlan } = getPreferredCreditPlans(creditPlans || {})
    const hideForm = globallyOutOfStock || endOfLineOutOfStock || preorderUnavailable
    const now = prices && prices.attributes.now && `£${prices.attributes.now.toFixed(2)}`
    const { addToTrolley } = this.refs
    const showAddToTrolley = (deliverable || collectable) && !hideForm
    const trolleyTrackingOptions = { trackingPage: 'PDP', trackingPageId: partNumber }
    const { trackUpdateTrolleyQuantity, onAccordionChange } = this
    const breadcrumbOptions = { currentCategoryName: name, ancestors: breadcrumb, brand }
    const { currentlyInViewport } = this.state
    const nameOptions = { productName: name, catNumber: productId }
    const badgesOptions = { badges, priorityMeta, energyValue: energy[0]?.attributes?.energyEfficiencyClass?.value }
    const { overallRating, reviewCount } = reviewStatistics.attributes || {}
    const reviewsFlagOptions = { overallRating, reviewCount, breadcrumb, partNumber, attributes }
    const genericFlagOptions = { offers, bundles, productId, essentialExtras }
    const { isLocalised, collectionMessageKey, deliveryMessageKey } = storeLocator
    const notInAOStock =
      isLocalised &&
      (!collectable || AoOosMessageKeys.includes(collectionMessageKey)) &&
      (!deliverable || AoOosMessageKeys.includes(deliveryMessageKey))
    const isAFSProduct = TEMPLATE_TYPE === 'AFS'

    const attributeSelectorOptions = {
      variants: variants?.attributes?.variants,
      partNumber,
      displaySwatchMessage: legalText?.displaySwatchMessage,
      quantity,
      breadcrumb,
      categories,
      digitalDownload,
      PDP_V2_FLAG
    }
    const { specificationList, pictogramList } =
      ((SPECIFICATION_TABLE || COMPARISON_ATTRIBUTES) && transformSpecification(comparison, REMOVED_SPECIFICATIONS)) ||
      {}

    const descriptionOptions = {
      descriptionText: description,
      partNumber,
      media,
      specificationList
    }
    const { usdz: { model } = {}, gltf } = ar
    const reviewsOptions = {
      partNumber,
      attributes,
      breadcrumb,
      onAccordionChange,
      ratingSummary
    }
    const qAndAOptions = {
      partNumber,
      attributes,
      breadcrumb,
      onAccordionChange,
      ASK_QUESTION
    }
    const genericAccordionOptions = {
      offers,
      bundles,
      partNumber: productId,
      price: prices && prices.attributes,
      productName: name,
      onAccordionChange
    }
    // Fix to stop special offer badging appearing without offer description on habitat pdps
    if (process.env.BRAND === 'HABITAT') {
      const descriptionForOfferExists =
        genericAccordionOptions?.offers?.length &&
        genericAccordionOptions?.offers?.some(
          offer => offer?.type === 'specialoffer' && offer?.attributes?.longDescription
        )
      if (!descriptionForOfferExists) {
        const newBadges = badgesOptions.badges.filter(badge => badge.attributes.badgeReference !== 'special_offer')
        badgesOptions.badges = newBadges
      }
    }
    const nutritionAccordionOptions = {
      ...nutrition,
      onAccordionChange
    }
    const matchingAccessoriesOptions = {
      mainProduct: {
        partNumber,
        productId,
        productName: name,
        price: prices && prices.attributes
      },
      onAccordionChange
    }
    const { isWarrantyItem } = attributes
    const additionalInformationOptions = { texts: legalText, isWarrantyItem, warrantyProductDetails }

    const alternativesOptions = {
      type: 'alternatives',
      parentPartNumber: partNumber
    }
    const shopCollectionOptions = {
      type: 'shopCollection',
      parentPartNumber: partNumber
    }

    const wishListOptions = { partNumber }
    const productCareOptions = {
      host: {
        hostPartNumber: partNumber,
        hostProductName: name,
        hostPrice: prices && prices.attributes.now
      },
      warrantyProductDetails,
      warranties: (productCare && productCare.warranties) || [],
      warrantyItem: attributes.isWarrantyItem
    }

    const ArgosCardOptions = {
      productInfo: attributes,
      prices: prices && prices.attributes,
      ArgosCardPlan: highestPriorityArgosCardPlan
    }

    const featuredProductsOptions = {
      partNumber,
      ancestors: breadcrumb
    }
    const trolleyQuantityOptions = {
      onChange: trackUpdateTrolleyQuantity,
      partNumber,
      maximumQuantity
    }

    const productList = [
      {
        id: partNumber,
        price: now ? now.slice(1) : '',
        quantity,
        ...(partNumber.toString().startsWith('tuc') && { parentId: parentId || '' })
      }
    ]

    const trolleyButtonTracking = AddToTrolley.onAddToTrolleyModalOpen(productList)
    const trolleyButtonOnErrorTracking = clickOrigin => (errorCode, errorText) => {
      setTimeout(() => {
        AddToTrolley.onAddToTrolleyModalError(
          productList,
          errorCode,
          errorText
        )(clickOrigin, {
          errorMessage: document.querySelector('div [kind="error"]')?.innerText || ''
        })()
      })
    }
    const fulfilmentBoxOptions = {
      addToTrolley,
      attributes,
      quantity,
      trolleyButtonTracking,
      trolleyButtonOnErrorTracking,
      productList,
      variants: variants?.attributes?.variants
    }
    const trolleyButtonMainOptions = {
      partNumber,
      full: true
    }

    const trolleyButtonTrackingParams = {
      clickOrigin: 'PDP:mainATT',
      products: productList
    }

    const trolleyButtonStickyOptions = {
      onClick: trolleyButtonTracking('PDP:stickBarATT'),
      onError: trolleyButtonOnErrorTracking('PDP:stickBarATT'),
      partNumber,
      full: true,
      openView: true
    }

    const trolleyButtonStickyTrackingParams = {
      clickOrigin: 'PDP:stickBarATT',
      products: productList
    }

    const { allCookies } = this.props
    const BRAND = process.env.BRAND || 'ARGOS'
    const isTuMobileLayout = BRAND === 'TU'

    const hasAvailabilityInfo = TEMPLATE_TYPE === 'TU_ON_ARGOS' || TEMPLATE_TYPE === 'TU'
    const addToTrolleyButtonOptions = {
      trolleyQuantityOptions,
      trolleyButtonMainOptions,
      trolleyButtonTrackingParams,
      warrantyPartNumber: warrantyProductDetails?.id, // maybe Remove for TUONARGOS
      warrantyItem: attributes.isWarrantyItem, // maybe Remove for TUONARGOS
      showAddToTrolley,
      categories: breadcrumb,
      hasAvailabilityInfo
    }
    const stickyNavOptions = { currentlyInViewport, offers, productId, globallyOutOfStock }
    const addToTrolleyStickyOptions = {
      name,
      now,
      trolleyQuantityOptions,
      trolleyButtonStickyOptions,
      trolleyButtonStickyTrackingParams,
      warrantyPartNumber: warrantyProductDetails?.id, // maybe Remove for TUONARGOS
      warrantyItem: attributes.isWarrantyItem, // maybe Remove for TUONARGOS
      showAddToTrolley,
      categories: breadcrumb,
      hasAvailabilityInfo,
      isMadeToOrder,
      isPDPV2Enabled: PDP_V2_FLAG,
      ...stickyNavOptions
    }
    const trolleyModalOptions = {
      hideExtras: ATT_MODAL_HIDE_EXTRAS,
      hideCategories: ATT_MODAL_HIDE_CATEGORIES
    }
    const addToTrolleyModalOptions = {
      showAddToTrolley,
      trolleyModalOptions,
      trolleyTrackingOptions
    }
    const mediaPlayerOptions = {
      partNumber,
      media,
      model,
      gltf,
      location: 'product',
      showShopSimilarButton: !attributes.isWarrantyItem && !isMadeToOrder
    }
    const cnetOptions = {
      partNumber,
      isCNETContent: !CNET ? false : isCNETContent,
      onAccordionChange
    }

    const habitatDimensionOptions = {
      images: media.images,
      dimensions
    }

    const energyLabelOptions = {
      images: media?.images,
      attributes: energy[0]?.attributes,
      onAccordionChange
    }

    const mainClassList = `pdp-main ${PDP_V2_FLAG ? 'pdp-v2-main' : ''}`
    const messageList = [
      'Sorry, we can’t show the price here right now.',
      `Add it to your ${ITEM_CONTAINER} to see the correct price.`
    ]

    const promotionOptions = { partNumber, name }

    const pricingModuleOptions = {
      prices,
      genericFlagOptions,
      attributeSelectorOptions,
      fulfilmentBoxOptions,
      productCareOptions,
      addToTrolleyModalOptions,
      addToTrolleyButtonOptions,
      addToTrolleyStickyOptions,
      wishListOptions,
      ArgosCardOptions,
      creditPlans,
      messageList,
      promotionOptions,
      partNumber,
      brand,
      ratingSummary,
      matchingAccessoriesOptions,
      globallyOutOfStock,
      FREQUENTY_BROUHT_TOGETHER,
      GO_IN_STORE,
      NECTAR,
      ESSENTIAL_EXTRAS,
      PAYPAL_IFC_MESSAGING,
      SHOW_ARGOSCARD_LOGO_FINANCE_ACCORDION,
      PAYPAL_MESSAGING,
      KLARNA_CREDITPLAN,
      KLARNA_MESSAGING,
      digitalDownload,
      isMadeToOrder,
      brandLogoUrl,
      allCookies,
      badges
    }

    const accordionsSectionOptions = {
      cnetOptions,
      reviewsOptions,
      qAndAOptions,
      genericAccordionOptions,
      nutrition: nutritionAccordionOptions,
      matchingAccessoriesOptions,
      habitatDimensionOptions,
      energyLabelOptions,
      FREQUENTY_BROUHT_TOGETHER,
      globallyOutOfStock,
      hasDeliveryAccordion: isMadeToOrder || (fulfilmentAgent === 'ADDO' && !sdf)
    }
    const Comparison = ({ screenSize }) => {
      if (COMPARISON_ATTRIBUTES) {
        return (
          <ErrorBoundary>
            <ComparisonAttributes attributes={specificationList} type={screenSize} parentId={parentId} />
          </ErrorBoundary>
        )
      }
      return <></>
    }

    const SpecificationTable = ({ screenSize }) => {
      if (SPECIFICATION_TABLE) {
        const SpecificationElement = (
          <ErrorBoundary>
            <SpecificationContainer {...{ specificationList, pictogramList, screenSize }} />
          </ErrorBoundary>
        )
        if (screenSize === 'desktop') {
          return <LazyHydrate whenIdle>{SpecificationElement}</LazyHydrate>
        }
        return SpecificationElement
      }
      return <></>
    }

    const hasCompleteTheLook = COMPLETE_THE_LOOK && (
      <div className='xs-block'>
        <ErrorBoundary>
          <InView
            triggerOnce
            rootMargin='0px 0px 600px 0px'
            onChange={inView => inView && this.setState({ loadRecommender: true })}
          >
            {this.state.loadRecommender && (
              <Recommender heading='Complete The Look' partNumber={partNumber} type='default' />
            )}
          </InView>
        </ErrorBoundary>
      </div>
    )

    //  Shop the collection
    const hasShopCollection = SHOP_COLLECTION && (
      <ErrorBoundary>
        <InView
          as='div'
          triggerOnce
          rootMargin='0px 0px 500px 0px'
          onChange={inView => inView && this.setState({ loadShopCollection: true })}
        >
          {this.state.loadShopCollection && <AlternativesHOC {...shopCollectionOptions} />}
        </InView>
      </ErrorBoundary>
    )
    //  or how about these...
    const hasAlternatives = (
      <ErrorBoundary>
        <InView
          as='div'
          triggerOnce
          rootMargin='0px 0px 500px 0px'
          onChange={inView => inView && this.setState({ loadAlternatives: true })}
        >
          {this.state.loadAlternatives && (
            <AlternativesHOC {...alternativesOptions} setNoOHATRecsExist={this.setNoOHATRecsExist} />
          )}
        </InView>
      </ErrorBoundary>
    )

    // These are in stock for you...
    const hasOOSAlternatives = notInAOStock && (
      <section
        className={!PDP_V2_FLAG ? DESCRIPTION_CLASS : `${MEDIA_CLASS} ds-m-0`}
        data-test='not-in-stock-alternatives'
      >
        <ErrorBoundary>
          <AlternativesHOC {...alternativesOptions} type='avAlternatives' />
        </ErrorBoundary>
      </section>
    )

    //  small print copy
    const showAdditionalInformation = (
      <div className='container'>
        <ErrorBoundary>
          <LazyHydrate ssrOnly>
            <AdditionalInformation {...additionalInformationOptions} />
          </LazyHydrate>
        </ErrorBoundary>
      </div>
    )

    //  featured products
    const hasFeaturedProducts = FEATURED_PRODUCTS && brand !== 'Apple' && (
      <InView
        as='div'
        onChange={inView => inView && this.setState({ featuredProductsLoaded: true })}
        rootMargin='0px 0px 500px 0px'
        triggerOnce
      >
        {this.state.featuredProductsLoaded && (
          <ErrorBoundary>
            <FeaturedProductsContainer {...featuredProductsOptions} />
          </ErrorBoundary>
        )}
      </InView>
    )

    const customerContent = CUSTOMER_GENERATED_CONTENT && (
      <LazyHydrate whenIdle>
        <CustomerGeneratedContentWrapper
          brand={BRAND}
          className={PDP_V2_FLAG ? 'pdp-v2-cgc' : `${DESCRIPTION_CLASS} pdp-content`}
          productId={productId}
          isFullWidth={isMadeToOrder}
        />
      </LazyHydrate>
    )

    const showCustomerContent = PDP_V2_FLAG ? (
      <div className={`${DESCRIPTION_CLASS} pdp-content`}>{customerContent}</div>
    ) : (
      customerContent
    )

    const trevorSummarySection = ASK_TREVOR_ENABLED ? (
      <ErrorBoundary>
        <AskTrevorCTA name={name} />
      </ErrorBoundary>
    ) : null

    if (isMadeToOrder) {
      const madeToOrderProps = {
        ...this.props,
        showMediaGalleryGrid: isMadeToOrder,
        pricingModuleOptions,
        BRAND,
        badgesOptions,
        breadcrumbOptions,
        reviewsFlagOptions,
        mediaPlayerOptions,
        accordionsSectionOptions,
        hasCompleteTheLook,
        hasShopCollection,
        hasAlternatives,
        showAdditionalInformation,
        hasFeaturedProducts,
        descriptionOptions,
        onAccordionChange,
        customerContent,
        trevorSummarySection
      }

      return <MadeToOrderTemplate {...madeToOrderProps} />
    }
    const energyPDF = badgesOptions.energyValue && mediaPlayerOptions.media?.pdfs?.find(pdf => pdf.includes('D010'))

    const isInCategoryExperiencesTest = isInCategoryExperiencesGroup(
      allCookies,
      CATEGORY_EXPERIENCES_TEMPLATE_ENABLED,
      BRAND,
      breadcrumb
    )

    const DEFAULT_TEMPLATE_MEDIA_CLASS = isInCategoryExperiencesTest ? 'xs-12--none md-7 xl-8' : MEDIA_CLASS
    const DEFAULT_TEMPLATE_PRICING_CLASS = isInCategoryExperiencesTest
      ? 'xs-12--none md-5--none xl-4--none'
      : PRICING_CLASS

    const additionalContentSectionProps = isInCategoryExperiencesTest
      ? {
          isAccordion: true,
          accordionOptions: { hasBorderTop: true },
          className: `pdp-accordions`,
          showCategoryNumber: true
        }
      : { className: `${DESCRIPTION_CLASS} pdp-content` }

    const HeadingSection =
      isInCategoryExperiencesTest || PDP_V2_FLAG ? (
        <ErrorBoundary>
          <DefaultHeadingSection
            name={name}
            catNumber={PDP_V2_FLAG ? nameOptions.catNumber : null}
            energyPDF={energyPDF}
            {...{ badgesOptions, reviewsFlagOptions }}
          />
        </ErrorBoundary>
      ) : null

    return (
      <OverwriteThemeIfNeeded TEMPLATE_TYPE={TEMPLATE_TYPE}>
        <main className={mainClassList} itemProp='mainEntityOfPage' itemScope itemType='https://schema.org/Product'>
          {/* Component to update structured data availability after frontend availability fetch */}
          {hasAvailabilityInfo && <StructuredDataAvailabilityUpdater partNumber={partNumber} />}
          <ErrorBoundary>
            <LazyHydrate ssrOnly>
              <div className='prop-bar'>
                <Propbar brand={BRAND.toLocaleLowerCase()} />
              </div>
            </LazyHydrate>
          </ErrorBoundary>
          <div className={`container ${PDP_V2_FLAG ? 'pdp-v2-container' : ''}`}>
            {BREADCRUMB && (
              <LazyHydrate whenIdle>
                <BreadcrumbSection className='xs-row pdp-breadcrumbs' {...{ breadcrumbOptions, PDP_V2_FLAG }} />
              </LazyHydrate>
            )}
            <Wrapper enableFlex={isInCategoryExperiencesTest || PDP_V2_FLAG} isAFSProduct={isAFSProduct && PDP_V2_FLAG}>
              <LazyHydrate whenIdle>
                <MediaGalleryBox
                  className={`${DEFAULT_TEMPLATE_MEDIA_CLASS} pdp-core`}
                  removeMobileTopBorders
                  removeMobileBottomBorders
                >
                  <MediaGallerySection
                    isTuMobileLayout={isTuMobileLayout}
                    className={!PDP_V2_FLAG ? `${DEFAULT_TEMPLATE_MEDIA_CLASS} pdp-core` : ''}
                    {...{ mediaPlayerOptions, nameOptions, badgesOptions, reviewsFlagOptions, energyLabelOptions }}
                    isPortrait={MEDIA_PORTRAIT}
                    isProductCare={attributes.isWarrantyItem}
                    isInCategoryExperiencesGroup={isInCategoryExperiencesTest}
                    energyPDF={energyPDF}
                    isPdpV2Enabled={PDP_V2_FLAG}
                  />
                </MediaGalleryBox>
                <section
                  data-test='pdp-right'
                  className={`${DEFAULT_TEMPLATE_PRICING_CLASS} pdp-right ${PDP_V2_FLAG ? 'pdp-v2-right' : ''}`}
                >
                  <PricingModuleSection
                    isTuMobileLayout={isTuMobileLayout}
                    type={TEMPLATE_TYPE}
                    pricingModuleOptions={pricingModuleOptions}
                    WISHLIST={WISHLIST}
                    SOLD_BY_ARGOS={SOLD_BY_ARGOS}
                    breadcrumb={breadcrumb}
                    MONTHLY_PAYMENT_PLAN={MONTHLY_PAYMENT_PLAN}
                    showAttributeSelector
                    headingSection={HeadingSection}
                    trevorSummarySection={trevorSummarySection}
                  />
                </section>
              </LazyHydrate>
              {hasOOSAlternatives}

              {showCustomerContent}

              <LazyHydrate whenIdle>
                <ContentSection
                  {...additionalContentSectionProps}
                  descriptionId='pdp-description'
                  onAccordionChange={onAccordionChange}
                  {...{ descriptionOptions }}
                >
                  <SpecificationTable screenSize='mobile' />
                  <Comparison screenSize='mobile' />
                </ContentSection>
              </LazyHydrate>
              <Comparison screenSize='desktop' />
              <SpecificationTable screenSize='desktop' />

              {!PDP_V2_FLAG && (
                <>
                  <LazyHydrate whenIdle>
                    <AccordionsSection
                      className='xs-12--none accordion-container pdp-accordions'
                      {...accordionsSectionOptions}
                    />
                    {hasCompleteTheLook}
                  </LazyHydrate>
                </>
              )}
            </Wrapper>
          </div>
          {PDP_V2_FLAG && (
            <div className='pdp-white-bg'>
              <div className='container'>
                <LazyHydrate whenIdle>
                  <AccordionsSection
                    className='xs-12--none accordion-container pdp-accordions'
                    {...accordionsSectionOptions}
                  />
                  {hasCompleteTheLook}
                </LazyHydrate>
                <div id='shop-similar-scroll-target' />
                {hasShopCollection}
                {hasAlternatives}
                {showAdditionalInformation}
                {hasFeaturedProducts}
              </div>
            </div>
          )}
          {!PDP_V2_FLAG && (
            <>
              <div id='shop-similar-scroll-target' />
              {hasShopCollection}
              {hasAlternatives}
              {showAdditionalInformation}
              {hasFeaturedProducts}
            </>
          )}
          <BackToTop />
        </main>
      </OverwriteThemeIfNeeded>
    )
  }

  onAccordionChange = (name, show) => {
    const { currentlyInViewport } = this.state
    return this.setState({
      currentlyInViewport: { ...currentlyInViewport, [name]: { ...currentlyInViewport[name], isOpen: show } }
    })
  }
}

DefaultTemplate.propTypes = {
  PDP_V2_FLAG: PropTypes.bool,
  allCookies: PropTypes.object
}

const WrappedDefaultTemplate = props => {
  return (
    <FeatureFlagContextConsumer>
      <DefaultTemplate {...props} />
    </FeatureFlagContextConsumer>
  )
}

export default withCookies(WrappedDefaultTemplate)
export { DefaultTemplate }
